module.exports = __webpack_public_path__ + "static/member-profile-g-panda-8912f95ddc15e27b45c58bf89a2e156f.jpg";